export default class AdminApplicationsJwtService {
  axiosIns = null

  jwtConfig = null

  constructor(axiosIns, jwtConfig) {
    this.axiosIns = axiosIns;
    this.jwtConfig = jwtConfig;
  }

  create(payload = {}) {
    return this.axiosIns.post(this.jwtConfig.main.applicationsEndpoint, payload, {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    })
  }

  // rotate: true keeps the previous token valid for overlapHours so the partner can switch without downtime
  createAccessToken(application_id, { rotate = false, overlapHours = 24 } = {}) {
    const params = rotate ? { rotate: true, overlap_hours: overlapHours } : {}
    return this.axiosIns.get(`${this.jwtConfig.main.applicationsEndpoint}/${application_id}/access-token/generate`, { params })
  }

  // JSON on purpose: only the integration fields change, nothing else on the application
  updateIntegration(id, payload = {}) {
    return this.axiosIns.put(`${this.jwtConfig.main.applicationsEndpoint}/${id}/integration`, payload)
  }

  rotateWebhookSecret(id) {
    return this.axiosIns.post(`${this.jwtConfig.main.applicationsEndpoint}/${id}/webhook-secret/rotate`, {})
  }

  webhookDeliveries(id, params = {}) {
    return this.axiosIns.get(`${this.jwtConfig.main.applicationsEndpoint}/${id}/webhook-deliveries`, { params })
  }

  // calls the application made with its application token: { days, limit, failures_only }
  apiUsage(id, params = {}) {
    return this.axiosIns.get(`${this.jwtConfig.main.applicationsEndpoint}/${id}/api-usage`, { params })
  }

  sendWebhookTest(id) {
    return this.axiosIns.post(`${this.jwtConfig.main.applicationsEndpoint}/${id}/webhook-test`, {})
  }

  update(id, payload = {}) {
    return this.axiosIns.put(`${this.jwtConfig.main.applicationsEndpoint}/${id}`, payload, {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    })
  }

  assignApplicationsToUser(id, payload = {}) {
    return this.axiosIns.post(`${this.jwtConfig.main.applicationsEndpoint}/users/${id}/grant`, payload)
  }

  delete(id) {
    return this.axiosIns.delete(`${this.jwtConfig.main.applicationsEndpoint}/${id}`)
  }

  get(id) {
    return this.axiosIns.get(`${this.jwtConfig.main.applicationsEndpoint}/${id}`)
  }

  list(params) {
    return this.axiosIns.get(this.jwtConfig.main.applicationsEndpoint, {
      params
    })
  }
}
